import { DateTime } from "luxon";

export enum BetPeriod {
	today = "today",
	last3days = "last3days",
	last7days = "last7days",
	last14days = "last14days",
	last30days = "last30days",
	last60days = "last60days",
	custom = "custom",
	all = "all",
}

export const betPeriods = [
	{
		name: "TODAY",
		value: BetPeriod.today,
		getTimeInterval: () => {
			return {
				from: DateTime.now().startOf("day").toUTC().toString(),
				to: DateTime.now().endOf("day").toUTC().toString(),
			};
		},
	},
	{
		name: "LAST_3_DAYS",
		value: BetPeriod.last3days,
		getTimeInterval: () => {
			return {
				from: DateTime.now()
					.minus({ days: 3 })
					.startOf("day")
					.toUTC()
					.toString(),
				to: DateTime.now().toUTC().toString(),
			};
		},
	},
	{
		name: "LAST_7_DAYS",
		value: BetPeriod.last7days,
		getTimeInterval: () => {
			return {
				from: DateTime.now()
					.minus({ days: 7 })
					.startOf("day")
					.toUTC()
					.toString(),
				to: DateTime.now().toUTC().toString(),
			};
		},
	},
	{
		name: "LAST_14_DAYS",
		value: BetPeriod.last14days,
		getTimeInterval: () => {
			return {
				from: DateTime.now()
					.minus({ days: 14 })
					.startOf("day")
					.toUTC()
					.toString(),
				to: DateTime.now().toUTC().toString(),
			};
		},
	},
	{
		name: "LAST_30_DAYS",
		value: BetPeriod.last30days,
		getTimeInterval: () => {
			return {
				from: DateTime.now()
					.minus({ days: 30 })
					.startOf("day")
					.toUTC()
					.toString(),
				to: DateTime.now().toUTC().toString(),
			};
		},
	},
	{
		name: "LAST_60_DAYS",
		value: BetPeriod.last60days,
		getTimeInterval: () => {
			return {
				from: DateTime.now()
					.minus({ days: 60 })
					.startOf("day")
					.toUTC()
					.toString(),
				to: DateTime.now().toUTC().toString(),
			};
		},
	},
	{
		name: "CUSTOM",
		value: BetPeriod.custom,
		getTimeInterval: () => {
			return null;
		},
	},
];
